// extracted by mini-css-extract-plugin
export var contentBody = "_a9-9";
export var headerImage = "_a9-2";
export var imageButton = "_a9-7";
export var imageButtonIcon = "_a9-8";
export var imageHeader = "_a9-4";
export var imageHeaderText = "_a9-5";
export var imageOverlay = "_a9-3";
export var imageTitle = "_a9-6";
export var imageWrapper = "_a9-1";
export var taskList = "_a9-a";
export var widget = "_a9-0";